import { render, staticRenderFns } from "./SelectProduitCerealeComponent.vue?vue&type=template&id=53c56ff8"
import script from "./SelectProduitCerealeComponent.vue?vue&type=script&lang=js"
export * from "./SelectProduitCerealeComponent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports